import { GqlFetcherType } from "src/lib/fetcher";
import React from "react";

const GqlClientContext = React.createContext<GqlFetcherType>(null);

export default GqlClientContext;
